import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../../store'

interface ICompanySliceState {
  selectedSecurityIdToCompare: string
}

const initialState: ICompanySliceState = {
  selectedSecurityIdToCompare: ''
}

const Slice = createSlice({
  name: '@module/markets/company',
  initialState,
  reducers: {
    SetSelectedSecurityIdToCompare: (state, action: PayloadAction<string>) => {
      state.selectedSecurityIdToCompare = action.payload
    }
  }
})

export const { SetSelectedSecurityIdToCompare } = Slice.actions
export const getSelectedSecurityIdToCompare = (state: RootState) =>
  state.modules.markets.company.selectedSecurityIdToCompare
export default Slice.reducer
